import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { ProductImage } from 'anf-core-react';
import ImagePlaceholder from './ImagePlaceholder';

const MobileImageSlider = forwardRef(({
  productImages,
  onClick,
  handleImageErrorOrRemoval,
}, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const loadedImages = useRef(0);
  let totalImages = productImages.length;

  const handleImageLoad = (isError) => {
    loadedImages.current = isError === true ? loadedImages.current : loadedImages.current + 1;
    if (loadedImages.current === totalImages) {
      setIsLoading(false);
      requestAnimationFrame(() => {
        imageSliderRef.current.scrollTo({ left: 0, behavior: 'auto' });
      });
    }
  };

  const handleImageError = (imageId) => {
    setIsLoading(false);
    totalImages -= 1;
    handleImageErrorOrRemoval(imageId);
    const hasError = true;
    handleImageLoad(hasError);
  };

  const imageSliderRef = useRef(null);

  const handleImageClick = (event, imageDetails) => {
    onClick(event, imageDetails);
    imageSliderRef.current?.focus();
  };

  const setSliderFocusOnTouchEnd = () => {
    imageSliderRef.current?.focus();
  };

  useImperativeHandle(ref, () => ({
    clearMobileImageLoaderCount: () => {
      setIsLoading(true);
      loadedImages.current = 0;
    },
    getLoadedImagesCount: () => loadedImages.current,
  }));

  const setAltText = (index) => `Product ${index}`;

  return (
    <section className="pdp-mobile-image-slider-wrapper">
      {isLoading && (
        <ImagePlaceholder singleView isMobile />
      )}
      <div className="pdp-mobile-image-slider" ref={imageSliderRef} data-testid="product-carousel-mobile">
        {productImages?.map((imageDetails, index) => (
          <button
            className="pdp-mobile-image-wrapper"
            key={imageDetails?.mainImageSrc}
            onTouchEnd={setSliderFocusOnTouchEnd}
          >
            <ProductImage
              alt={setAltText(index)}
              data-testid="product-image"
              classList="product-image-react"
              src={imageDetails?.mainImageSrc}
              onError={() => handleImageError(imageDetails?.imageId)}
              onClick={(event) => handleImageClick(event, imageDetails)}
              onLoad={handleImageLoad}
              data-size=""
            />
          </button>
        ))}
      </div>
    </section>
  );
});

export default MobileImageSlider;
